import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CB } from '../../../constants/paymentMethods';

import ScelliusComponent from '../../iframes/scellius/ScelliusComponent';

import './FunnelPaymentStepStyle.scss';

const FunnelPaymentStep = ({ userInfo, partnerId, order, paymentType }) => {
    return (
        <div id="payment-step-container">
            {paymentType === CB && (
                <ScelliusComponent orderId={order.id} partnerId={partnerId} userInfo={userInfo} />
            )}
        </div>
    );
};

FunnelPaymentStep.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    paymentType: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON,
        order: state.ebon.createdOrder
    };
};

export default connect(mapStateToProps)(FunnelPaymentStep);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/FunnelPaymentStep.js